import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { useEffect, useRef, useState } from 'react';
import { Label } from '../label/Label';

export interface ISwitchProps extends BaseProps {
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  /**
   * Zda je ve výchozím stavu zaškrtnutý - pro uncontrolled mód.
   */
  defaultChecked?: boolean;
  /**
   * Title pro switch, takto z důvbodu zachování zpětné kompatbility při změně switch komponenty, pokud není uveden, je použit title.
   */
  innerLabel?: string;
  /**
   * Title pro switch když je zaškrtnutý, pokud není uveden, je použit innerLabel.
   */
  innerLabelChecked?: string;
  /**
   * Standardně je label (children) zobrazen vlevo od switche, pokud je zde true, je zobrazen vpravo.
   */
  labelRight?: boolean;
}

export type SwitchProps = ISwitchProps;

export const Switch: React.FC<SwitchProps> = ({
  className,
  checked,
  onChange,
  disabled,
  defaultChecked,
  title,
  innerLabel,
  innerLabelChecked,
  children,
  labelRight,
  dataTest,
  ...other
}) => {
  const firstRender = useRef<boolean>(true);
  const idRef = useRef<string | undefined>(undefined);
  if (firstRender.current) {
    idRef.current = uuidv4();
  }

  const [ch, setCh] = useState(
    checked !== undefined ? checked : defaultChecked
  );

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setCh(checked);
    }
  }, [checked]);

  let titleText;
  if (ch) {
    titleText = innerLabelChecked || innerLabel || title;
  } else {
    titleText = innerLabel || title;
  }

  return (
    <div
      className={classNames(className, Classes.SWITCH, {
        [Classes.SWITCH_CHECKED]: ch,
        [Classes.SWITCH_UNCHECKED]: !ch,
        [Classes.SWITCH_DISABLED]: disabled,
        [Classes.SWITCH_LR]: labelRight,
      })}
      {...other}
    >
      <div className={Classes.SWITCH_OW}>
        {!labelRight && children && (
          <label htmlFor={idRef.current}>
            <Label>{children}</Label>
          </label>
        )}
        <div
          className={classNames(className, Classes.SWITCH_IN, {
            [Classes.SWITCH_CHECKED]: ch,
            [Classes.SWITCH_UNCHECKED]: !ch,
            [Classes.SWITCH_DISABLED]: disabled,
          })}
          title={titleText}
        >
          <div className={Classes.SWITCH_WRAPPER}>
            <input
              disabled={disabled}
              id={idRef.current}
              type="checkbox"
              data-test={dataTest ? `input-${dataTest}` : undefined}
              checked={!!ch}
              aria-checked={!!ch}
              onChange={(e) => {
                setCh(e.target.checked);
                onChange?.(e);
              }}
            />
            <div className={Classes.SWITCH_SW} />
          </div>
          <div className={Classes.SWITCH_TRACK} />
        </div>
      </div>
      {labelRight && children && (
        <label htmlFor={idRef.current}>
          <Label>{children}</Label>
        </label>
      )}
    </div>
  );
};
